(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["magniglide-first-offer"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => {
    const dialog = document.getElementById('MgFirstOffer');
    if (!dialog || !dialog.showModal) return;
    const form = dialog.querySelector('form');
    const key = 'mg-first10';
    const read = (storage, name) => { try { return storage.getItem(name); } catch { return null; } };
    const write = (storage, name, value) => { try { storage.setItem(name, value); } catch {} };
    let stopped = Number(dialog.dataset.cartCount) > 0;
    let timer;
    const close = () => {
      stopped = true;
      clearTimeout(timer);
      write(localStorage, key + '-dismissed', String(Date.now()));
      dialog.close();
    };
    dialog.querySelectorAll('[data-offer-close]').forEach(button => button.addEventListener('click', close));
    dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
    dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close(); } });
    document.addEventListener('submit', event => {
      if (!(event.target instanceof HTMLFormElement)) return;
      if (event.target === form) {
        write(sessionStorage, key + '-pending', '1');
      } else if (event.target.action.includes('/cart/add')) {
        stopped = true;
        clearTimeout(timer);
        write(sessionStorage, key + '-shopping', '1');
        if (dialog.open) dialog.close();
      } else if (event.target.querySelector('[name="contact[email]"]')) {
        stopped = true;
        clearTimeout(timer);
      }
    }, true);
    const show = () => {
      if (document.querySelector('dialog[open]')) return;
      dialog.showModal();
      write(sessionStorage, key + '-shown', '1');
    };
    if (dialog.querySelector('[data-offer-success]') && read(sessionStorage, key + '-pending')) {
      write(localStorage, key + '-subscribed', '1');
      write(sessionStorage, key + '-pending', '');
      show();
      return;
    }
    if (dialog.querySelector('[data-offer-errors]') && read(sessionStorage, key + '-pending')) {
      show();
      return;
    }
    const dismissed = Number(read(localStorage, key + '-dismissed') || 0);
    if (stopped || read(localStorage, key + '-subscribed') || read(sessionStorage, key + '-shown') || read(sessionStorage, key + '-shopping') || Date.now() - dismissed < 30 * 86400000) return;
    const attempt = async () => {
      if (stopped) return;
      if (document.hidden) { timer = setTimeout(attempt, 2000); return; }
      try {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {credentials:'same-origin'});
        if (!response.ok) return;
        const cart = await response.json();
        if (cart.item_count > 0 || stopped) return;
        if (document.activeElement?.matches('input,textarea,select') || document.querySelector('dialog[open]')) { timer = setTimeout(attempt, 5000); return; }
        show();
      } catch {}
    };
    timer = setTimeout(attempt, 6000);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
  } catch(e) { console.error(e); }
})();

})();
